"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionLabel = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionLabel = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    hideSubscription,
    subscription
  } = (0, _internal.useProduct)();
  if (Boolean(hideSubscription) || !subscription?.available) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.SUBSCRIPTION_LABEL),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      color: "success",
      label: translations.subscriptionLabel,
      size: "small",
      variant: "tag"
    })
  });
};
exports.SubscriptionLabel = SubscriptionLabel;
//# sourceMappingURL=SubscriptionLabel.js.map